import { newSalesSlice } from './reducer';

export const { successGetNewSales, requestGetNewSales } = newSalesSlice.actions;
